module.exports = __webpack_public_path__ + "static/media/table_column_total_row.f40b920a.png";